import { addToast, clearAll } from "./toast-state";
import { mountContainer } from "./container-mount";

const Api = (globalOptions = {}) => {
    return {
        show(message, options = {}) {
            mountContainer();
            const props = { message, ...globalOptions, ...options };
            return addToast(props);
        },
        clear() {
            clearAll();
        },
        success(message, options = {}) {
            options.type = "success";
            return this.show(message, options);
        },
        error(message, options = {}) {
            options.type = "error";
            return this.show(message, options);
        },
        info(message, options = {}) {
            options.type = "info";
            return this.show(message, options);
        },
        warning(message, options = {}) {
            options.type = "warning";
            return this.show(message, options);
        },
    };
};

export default Api;
